import React from 'react'
import {css, useTheme} from '@emotion/react'


export default function ControlDetailPanelDesktopLayout({control, children}) {
  const theme = useTheme()
  const styles = {
    root: css`
      height: 100%;

      display: flex;
      gap: 24px;
    `,
    control: css`
      flex: 1;

      display: flex;
      flex-direction: column;
      gap: 16px;

      min-width: 400px;
      width: 400px;
      max-width: 450px;
    `,
    detail: css`
      flex: 2;
      position: relative;
      overflow-y: auto;
    `,
  }

  return (
    <div css={styles.root}>
      <div css={styles.control}>
        {control}
      </div>
      <div css={styles.detail}>
        {children}
      </div>
    </div>
  )
}
